import { FC } from 'react';
import { Alert } from '@hopskipdrive/react-components';

interface SplitBillingProps {
  sharedBilling?: SharedBillingDetail;
}

export const SplitBillingBanner: FC<SplitBillingProps> = ({ sharedBilling }) => {
  const title =
    sharedBilling?.role === 'attending' ? 'Shared Ride - Attending District' : 'Shared Ride - Residence District';

  return (
    <>{sharedBilling && <Alert sx={{ mb: '24px' }} severity="info" title={title} message={sharedBilling?.message} />}</>
  );
};
